import notificationClient from '../../api/notificationClient';
import { Notify_Url, Locales_Url, Templates_Url } from '../../api/endpoints';
import type { ChannelType, BackendEnqueueResponse } from '../../schema/notification';
import type { FallbackRule } from '../../schema/rules/fallbackRule';

export interface NotifyPayload {
  metadata: { sourceModule: string; productId: string; referenceId: string };
  recipient: { name: string; email?: string; phone?: string; deviceTokens?: string[]; locale?: string };
  templateId: string;
  templateData: Record<string, unknown>;
  channels: ChannelType[];
  fallbacks?: FallbackRule[];
  idempotencyKey?: string;
}

export const sendNotification = async (payload: NotifyPayload): Promise<BackendEnqueueResponse> => {
  const { data } = await notificationClient.post<BackendEnqueueResponse>(Notify_Url, payload);
  return data;
};

export interface LocalesResponse {
  supported: string[];
  default: string;
  coverage?: unknown;
}

export const getLocales = async (): Promise<LocalesResponse> => {
  const { data } = await notificationClient.get<LocalesResponse>(Locales_Url);
  return data;
};

export interface TemplatesResponse {
  templates: string[];
}

export const getTemplates = async (): Promise<TemplatesResponse> => {
  const { data } = await notificationClient.get<TemplatesResponse>(Templates_Url);
  return data;
};
